import React from 'react';
import styled from "styled-components";

const WelcomeIntroductionSection = () => {
    return (
        <Container className="rounded-16 border border-gray200">
            <div className="row align-items-center">
                <div className="col-12 col-lg-7">
                    <div className="">
                        <h2 className="h1-bold ">خرید، رهن و اجاره در شهرهای مختلف ایران</h2>
                        <p className="mt-8 mt-lg-24">
                            ما در 2نبش به اهمیت دو اصل اطمینان و سرعت در معاملات املاک باور داریم و با داشتن 11 سال تجربه فعالیت در بازار املاک و جذب
                            بیش از 25000 مشاور املاک در خراسان، تهران و شمال تلاش می کنیم تا تغییری بزرگ در معاملات املاک کشور رقم بزنیم. در 2نبش با
                            اطمینان بین آگهی‌ها جست‌وجو کنید و به سرعت ملک مورد نظرتون رو پیدا کنید</p>
                    </div>
                </div>

                <div className="col-lg-1"/>

                <div className="col-12 col-lg-4 mt-32 mt-lg-0">
                    <img src="/_img/iran.png" className="img-fluid" alt="خرید، رهن و اجاره در شهرهای مختلف ایران"/>
                </div>
            </div>
        </Container>
    );
};

export default React.memo(WelcomeIntroductionSection);

// styles

const Container = styled.div`
  padding: 64px;
  
  @media (max-width: ${props => props.theme.screenXsMax}) {
      padding: 40px 24px;
  }
`;
